export const removeArrayItem = (array, item) => {
  const temp = [...array]
  const index = temp.indexOf(item);
  if (index > -1) { // only splice array when item is found
    temp.splice(index, 1); // 2nd parameter means remove one item only
  }
  return temp
}